import { ChangeDetectionStrategy, Component, ElementRef, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { Router } from '@angular/router';
import { CoursesService, PathsService, PortalConfigurationService, UrlService } from '@draeger-academy/common';
import { AuthenticationService } from '@draeger-academy/common/lib/services/authentication/authentication.service';
import { CartService } from '@draeger-academy/common/lib/services/cart/cart.service';
import { ConfigurationService } from '@draeger-academy/common/lib/services/configuration/configuration.service';
import { TranslateService } from '@ngx-translate/core';
import { Course } from 'models/course';
import { CartItem } from 'models/cartItem';
import { BehaviorSubject, delay, Observable, Subscription } from 'rxjs';
import { GenericModalService } from '../generic-modal';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'da-events',
    templateUrl: './events.component.html',
    styleUrls: ['./events.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class EventsComponent implements OnInit {
    @Input() events: CartItem[];
    @Input() course: Course;
    @Input() isCourseDetails = true;
    public currency = '';
    public dynamicParameter: string;
    public language: string;
    public courseDetail = 'event';
    public booking: string;
    public courseImage: string;
    public alt = '';
    public countryName = '';
    public showWarning = false;
    public hasFreeSeats = false;
    public currentYearEvents: CartItem[] = [];
    public nextYearEvents: CartItem[] = [];
    public currentYear;
    public nextYear;
    public yearOfEvent: string;
    public clickAddToCart = false;
    public currencyIsTheSameLikeOtherCourses: boolean;
    public courseTitle: string;
    public site: string;
    private _subscription: Subscription; 
    @ViewChildren('event') event: QueryList<ElementRef>;
    @ViewChild('overlay', { static: true }) private _overlay;
    @ViewChild('requirementsModal', { static: true }) private _requirementsModal;
    @ViewChild('notTheSameCurrencyModal', { static: true }) private _notTheSameCurrencyModal;
    public envApi = environment.APIEndpoint;
    @ViewChild('warningPrebooking', { static: true }) private _warnPrebooking;
    private _modalId: string;
    @ViewChild('overlayUpdate', { static: true }) private _overlayUpdate;

    @ViewChild('warn', { static: true }) private _warn;
    private _$showLogin: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showLogin$(): Observable<boolean> {
        return this._$showLogin.asObservable();
    }

    private _$dateFormat: BehaviorSubject<string> = new BehaviorSubject('');
    public get dateFormat$(): Observable<string> {
        return this._$dateFormat.asObservable();
    }

    private _$showCartUpdate: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showCartUpdate$(): Observable<boolean> {
        return this._$showCartUpdate.asObservable();
    }

    private _$showCartUpdatePrebooking: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showCartUpdatePrebooking$(): Observable<boolean> {
        return this._$showCartUpdatePrebooking.asObservable();
    }

    private _$location: BehaviorSubject<CartItem> = new BehaviorSubject<CartItem>(null);
    public get location$(): Observable<CartItem> {
        return this._$location.asObservable();
    }

    private _$events: BehaviorSubject<CartItem[]> = new BehaviorSubject(null);
    public get events$(): Observable<CartItem[]> {
        return this._$events.asObservable();
    }

    private _$showVat: BehaviorSubject<boolean> = new BehaviorSubject(false);
    public get showVat$(): Observable<boolean> {
        return this._$showVat.asObservable();
    }

    private _$pricePattern: BehaviorSubject<string> = new BehaviorSubject('');
    public get pricePattern$(): Observable<string> {
        return this._$pricePattern.asObservable();
    }
    private _$formattedPrice: BehaviorSubject<string> = new BehaviorSubject('');
    public get formattedPrice$(): Observable<string> {
        return this._$formattedPrice.asObservable();
    }
    private _$formattedPrice2: BehaviorSubject<string> = new BehaviorSubject('');
    public get formattedPrice2$(): Observable<string> {
        return this._$formattedPrice2.asObservable();
    }

    constructor(
        private _translateService: TranslateService,
        private _genericModalService: GenericModalService,
        public config: ConfigurationService,
        private _cartService: CartService,
        private _authenticationService: AuthenticationService,
        private _router: Router,
        private _urlService: UrlService,
        private _configurationService: ConfigurationService,
        private _pathsService: PathsService,
        private _portalConfigurationService: PortalConfigurationService,
        private _coursesService: CoursesService
    ) {
        _translateService.get('language').subscribe((res: string) => {
            this.language = res;
        });
    }

    ngOnInit() {
        this.site = this._configurationService.getCurrentSite();

        this.currentYear = new Date().getFullYear();
        this.nextYear = this.currentYear + 1;
        if (this.course) {
            if (this.course.unicodeTitle && this.course.unicodeTitle !== null && this.course.unicodeTitle !== '') {
                this.courseTitle = this.course.unicodeTitle;
            } else {
                this.courseTitle = this.course.name;
            }
            this.currency = this._coursesService.getCurrencies(this.course, this.site);           
            this.formatingPrice();
        }
        if (this.events && this.events.length > 1) {
            this._$events.next(
                this.events.sort((a: any, b: any) => {
                    return Date.parse(a.beginDateTime) - Date.parse(b.beginDateTime);
                })
            );
        }

        this._authenticationService.loggedIn().subscribe((data) => {
            if (data) {
                this._$showLogin.next(true);
            }
        });


        const isPortal = this._configurationService.isPartnerPage();
        if (isPortal) {
            this._$dateFormat.next(this.config.$portalPreferences.getValue().dateFormat);

        } else {
            this._$dateFormat.next('dd.MM.yyyy');
        }

        if (this._configurationService.isPartnerPage()) {
            this._translateService.stream('common').subscribe((translation) => {
                if (translation && translation.currency) {
                    if (translation.currency.ShowVATPrice === 'true') {
                        this._$showVat.next(true);
                    }
                }
            });
        }

        const _isPortal = this._configurationService.isPartnerPage();
        this._configurationService.portalVersion$.subscribe((portalVersion) => {
            this._checkIfWarningShouldBeShown(_isPortal, portalVersion);
        });

        if (this.course && this.course.events && this.course.events.length > 0) {
            this.currentYearEvents = [];
            this.course.events.forEach((el) => {
                if (el && el.freeSeats > 0) {
                    this.hasFreeSeats = true;
                }

                const dateEl = new Date(el.beginDateTime);
                if (dateEl.getFullYear() <= this.currentYear) {
                    this.currentYearEvents.push(el);
                } else if (dateEl.getFullYear() > this.currentYear) {
                    this.nextYearEvents.push(el);
                }
            });
        }
    }

    private _overlayRequiredHandler(): void {
        this._modalId = this._genericModalService.create(this._requirementsModal);
        this._genericModalService.open(this._modalId, this._requirementsModal, true);
    }

    private _overlayNotTheSameCurrency(): void {
        this._modalId = this._genericModalService.create(this._notTheSameCurrencyModal);
        this._genericModalService.open(this._modalId, this._notTheSameCurrencyModal, true);
    }

    private _checkIfWarningShouldBeShown(isPortal = false, portalVersion: string): void {
        const _shouldHaveCheckPrerequest =
            (!isPortal && this._configurationService.hasFeature('CheckPrerequest')) || (portalVersion === 'v2' && isPortal);
        this.showWarning = _shouldHaveCheckPrerequest;
    }

    public addToCart(eventId: string, eventDate) {
        const dateEl = new Date(eventDate);
        this.yearOfEvent = dateEl.getFullYear().toString();
        if (dateEl.getFullYear() <= this.currentYear) {
            this.yearOfEvent = 'currentYear';
        } else if (dateEl.getFullYear() > this.currentYear) {
            this.yearOfEvent = 'nextYear';
        }
        let _site = this._configurationService.getCurrentSite();
        if (this._configurationService.isPartnerPage()) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }
        this.currencyIsTheSameLikeOtherCourses = this._configurationService.checkIfCurrencyIsDifferentToCartItemsCurrency(
            _site,
            this.currency
        );
        this.clickAddToCart = true;
        this._cartService.ordersent = false;
        if (!this.currencyIsTheSameLikeOtherCourses) {
            this._overlayNotTheSameCurrency();
        } else {
            this._cartService.index = this._cartService.index + 1;
            this._subscription = this._authenticationService.loggedIn().pipe(delay(200 * this._cartService.index)).subscribe((data) => {
                if (data) {
                    this._cartService.checkPrerequirementsOfUser(eventId).then((data) => {
                        this._cartService.index = this._cartService.index > 0 ? this._cartService.index - 1 : 0;
                        if (
                            data &&
                            this.showWarning &&
                            !this.getBoolean(localStorage.getItem(`popup${eventId}`)) &&
                            !this.isCourseDetails &&
                            !this._cartService.ordersent
                        ) {
                            localStorage.setItem(`popup${eventId}`, 'true');
                            this._overlayRequiredHandler();
                        } else if (localStorage.getItem(`cartItems${_site}`)) {
                            const cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site}`)));
                            if (
                                (cartItems &&
                                    cartItems.events &&
                                    cartItems.events.filter((courseItem) => courseItem === eventId).length) ||
                                (cartItems &&
                                    cartItems.wishlist &&
                                    cartItems.wishlist.filter((courseItem) => courseItem === this.course.id).length)
                            ) {
                                if (this.clickAddToCart) {
                                    this._overlayWarnHandler();
                                }
                            } else {
                                this._cartService.addEventToCart(eventId);
                                this._overlayNotification();
                            }
                        } else if (!this._cartService.ordersent) {
                            this._cartService.addEventToCart(eventId);
                            this._overlayNotification();
                        }
                        this.clickAddToCart = false;
                    });
                    this._subscription.unsubscribe();
                } else {
                    if (localStorage.getItem(`cartItems${_site}`)) {
                        const cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site}`)));
                        if (cartItems && cartItems.events && cartItems.events.filter((courseItem) => courseItem === eventId).length) {
                            if (this.clickAddToCart) {
                                this._overlayWarnHandler();
                            }
                        } else if (
                            cartItems &&
                            cartItems.wishlist &&
                            cartItems.wishlist.filter((courseItem) => courseItem === this.course.id).length
                        ) {
                            if (this.clickAddToCart) {
                                this._overlayWarnHandler();
                            }
                        } else {
                            if (this.clickAddToCart) {
                                this._cartService.addEventToCart(eventId);
                                this._overlayNotification();
                            }
                        }
                    } else {
                        if (this.clickAddToCart) {
                            this._cartService.addEventToCart(eventId);
                            this._overlayNotification();
                        }
                    }
                    this.clickAddToCart = false;
                }
            });
        }
    }

    private _overlayWarnHandler(): void {
        this._modalId = this._genericModalService.create(this._warn);
        this._genericModalService.open(this._modalId, this._warn, true);
    }

    public closeModal() {
        if (this._modalId) {
            this._genericModalService.close(this._modalId);
        }
    }

    private async _overlayNotification() {
        this._$showCartUpdate.next(true);
        setTimeout(() => this._$showCartUpdate.next(false), 4000);
    }

    private async _overlayNotificationPrebooking() {
        this._$showCartUpdatePrebooking.next(true);
        setTimeout(() => this._$showCartUpdatePrebooking.next(false), 4000);
    }

    public goToCart() {
        this._$showCartUpdate.next(false);
        this.closeModal();
        this._cartService.goToCart();
    }

    public goToEventDetail(id) {
        const _path: any = this._pathsService.getEventDetailLink(id);
        this._router.navigate([_path]);
    }

    public goToCourseDetails() {
        const _detailPath = this._pathsService.getCourseDetailLink(this.course.id);
        this._router.navigate([_detailPath]);
    }
    private _overlayHandler(modal): void {
        if (modal) {
            this._modalId = this._genericModalService.create(this._overlay);
            this._genericModalService.open(this._modalId, this._overlay, true);
        }
    }

    public openOverlay(event: CartItem): void {
        this._configurationService.$siteSettings.subscribe((data) => {
            if (data && data.length > 0) {
                const _countriesData = data.filter((f) => f.key.toLowerCase() === 'countries')[0];
                _countriesData['value'].filter((obj) => {
                    if (obj.code === event.location.countryKey) {
                        this.countryName = obj.name;
                    }
                });
                this._$location.next(event);
                this._overlayHandler(true);
            }
        });
    }

    public addToWishlist() {
        let _site = this._configurationService.getCurrentSite();
        if (this._configurationService.isPartnerPage()) {
            this._configurationService.currentPortal$.subscribe((portalId) => {
                if (portalId) {
                    _site = portalId;
                }
            });
        }
        this.clickAddToCart = true;
        this._cartService.ordersent = false;
        if (localStorage.getItem(`cartItems${_site}`)) {
            const cartItems = JSON.parse(this._urlService.decode(localStorage.getItem(`cartItems${_site}`)));

            const eventInCart = [];
            this.course.events.forEach((el) => {
                eventInCart.push(cartItems.events.filter((item) => el.externalId === item));
            });

            if (
                cartItems &&
                cartItems.wishlist &&
                cartItems.wishlist.filter((courseItem) => this.course.id === courseItem) &&
                cartItems.wishlist.filter((courseItem) => this.course.id === courseItem).length
            ) {
                if (this.clickAddToCart) {
                    this._overlayWarnWishlistHandler();
                }
            } else {
                this._cartService.addCourseToWishlist(this.course.id);
                this._overlayNotificationPrebooking();
            }
        } else {
            this._cartService.addCourseToWishlist(this.course.id);
            this._overlayNotificationPrebooking();
        }
        this.clickAddToCart = false;
    }
    private _overlayWarnWishlistHandler(): void {
        this._modalId = this._genericModalService.create(this._warnPrebooking);
        this._genericModalService.open(this._modalId, this._warnPrebooking, true);
    }

    private getBoolean(value) {
        switch (value) {
            case true:
            case 'true':
            case 1:
            case '1':
            case 'on':
            case 'yes':
                return true;
            default:
                return false;
        }
    }

    public checkPrerequirements(eventId: string) {
        const localStorageExists = localStorage.getItem(`popup${eventId}`);

        if (this.getBoolean(localStorageExists)) {
            return false;
        } else {
            if (eventId && this.showWarning) {
                this._cartService.checkPrerequirementsOfUser(eventId).then((data) => {
                    return data;
                });
                // this._cartService.checkPrerequirements(eventId).then(
                //     (data) => {
                //         return data;
                //     },
                //     (error) => {
                //         return true;
                //     }
                // );
            } else {
                return false;
            }
        }
    }

    ngOnDestroy() {
        this.closeModal();
    }
    private formatingPrice(){      
        if (this._configurationService.isPartnerPage()) {
                this._portalConfigurationService.currencyPattern$.subscribe((currencyPattern) => {
                    this._$formattedPrice.next(this.formatPrice(this.course.prices[0].value, currencyPattern));
                    if (this.course.prices[1]){
                        this._$formattedPrice2.next(this.formatPrice(this.course.prices[1].value, currencyPattern));
                    }
                });

            this._translateService.stream('common').subscribe((translation) => {
                if (translation && translation.currency) {

                    if (translation.currency.ShowVATPrice === 'true') {
                        this._$showVat.next(true);
                    }
                }
            });
        } else {
            this._$pricePattern.next('#.##0,00 " $"');
            if (this.site === 'en_uk' || this.site === 'en_nz' || this.site === 'en_au' || this.site === 'fr_fr') {
                this._$pricePattern.next('#,##0.00 " $"');
            }

            if (this.course.prices.length > 0) {
                this._$formattedPrice.next(this.formatPrice(this.course.prices[0].value, this._$pricePattern.getValue()));
                if (this.course.prices[1]){
                    this._$formattedPrice2.next(this.formatPrice(this.course.prices[1].value, this._$pricePattern.getValue()));
                }
            } else {
                if (this.course.price){
                    this._$formattedPrice.next(this.formatPrice(this.course.price, this._$pricePattern.getValue()));
                }
            }           
            if (this._configurationService.hasFeature('ShowVATPrice')) {
                this._$showVat.next(true);
            }
        }
    }



    private formatPrice(price: any, formatPattern){
        if (formatPattern){
            return this._configurationService.formatPrice(price, formatPattern, this.currency);
        } else {
            return price;
        }
    }
}
